"use client";

import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PrecisionPsychiatryForModernLife from "./sections/PrecisionPsychiatryForModernLife";
import TheScienceOfTargetedTreatment from "./sections/TheScienceOfTargetedTreatment";
import CompassionateClinicalLeadership from "./sections/CompassionateClinicalLeadership";
import OurTreatmentPathways from "./sections/OurTreatmentPathways";
import AccessingCareAnywhere from "./sections/AccessingCareAnywhere";
import BeginYourJourneyToClarity from "./sections/BeginYourJourneyToClarity";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PrecisionPsychiatryForModernLife />
      <TheScienceOfTargetedTreatment />
      {/* <CompassionateClinicalLeadership /> */}
      <OurTreatmentPathways />
      <AccessingCareAnywhere />
      <BeginYourJourneyToClarity />
      <Footer />
    </div>;
}